import { render, staticRenderFns } from "./PlaceholderPage.vue?vue&type=template&id=5277716d&scoped=true&"
import script from "./PlaceholderPage.vue?vue&type=script&lang=js&"
export * from "./PlaceholderPage.vue?vue&type=script&lang=js&"
import style0 from "./PlaceholderPage.vue?vue&type=style&index=0&id=5277716d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5277716d",
  null
  
)

export default component.exports